"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Form.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : InputForm.js
* Description : Ce fichier contient la définition du composant InputForm 
*               Ce composant affiche un champ pour rentrer une donnée avec une fonction de validation de cette donnée
* Date de création : 23 septembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */

/**
* InputForm : ce lien affiche un champ pour rentrer des données
*
* Type : composant 
*
* Parametres : 
*  - error -- booléen pour remonter une erreur de validation de la donnée
*  - type -- type de la donnée (text, number...)
*  - label -- texte affiché au dessus du champ pour apporter des précisions sur la donnée à rentrer
*  - value -- valeur de la donnée
*  - setValue -- fonction pour mettre à jour la valeur de la donnée
*  - disabled -- booléen pour désactiver la saisie de ce champ et juste afficher sa valeur si elle dépend d'autres variables
*/function InputForm(_ref) {
  var error = _ref.error,
    type = _ref.type,
    label = _ref.label,
    value = _ref.value,
    setValue = _ref.setValue,
    disabled = _ref.disabled;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  return error ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: screenWidth > 1000 ? 'form-label flex-column' : screenWidth > 650 ? 'form-label-ss flex-column' : 'form-label-tr flex-column',
    children: [label, " :", /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      className: "form-input-error",
      type: type,
      value: value,
      onChange: function onChange(e) {
        return setValue(e.target.value);
      },
      disabled: disabled
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "form-error",
      children: "Ce champ est obligatoire !"
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
    className: screenWidth > 1000 ? 'form-label flex-column' : screenWidth > 650 ? 'form-label-ss flex-column' : 'form-label-tr flex-column',
    children: [label, ":", /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      className: "form-input",
      type: type,
      value: value,
      onChange: function onChange(e) {
        return setValue(e.target.value);
      },
      disabled: disabled
    })]
  });
}

// Les propTypes permettent de sécuriser les données en specifiant le type de donnée attendu pour une prop
InputForm.propTypes = {
  error: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  label: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  defaultValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  setValue: _propTypes["default"].func
};
var _default = exports["default"] = InputForm;